/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Team({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" fillRule="evenodd" clipPath="url(#Team_svg__a)" clipRule="evenodd"><path d="M4.386 9.645A2.87 2.87 0 0 0 7.003 7.96a3.6 3.6 0 0 0 2.014-.006 2.873 2.873 0 1 0 2.62-4.054 1 1 0 0 0-.086.006 3.6 3.6 0 0 0-7.102-.003L4.386 3.9a2.873 2.873 0 0 0 0 5.745M8 2.1a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8m-3.614 3 .063-.003A3.6 3.6 0 0 0 5.921 7.44 1.674 1.674 0 1 1 4.386 5.1m7.25 3.345c-.69 0-1.285-.42-1.54-1.018a3.6 3.6 0 0 0 1.455-2.333 1 1 0 0 0 .085.006 1.673 1.673 0 0 1 0 3.345" /><path d="M3.721 10.455c-1.57 0-2.943 1.043-3.412 2.556l-.097.314c-.265.858.352 1.775 1.283 1.775h13.032c.931 0 1.549-.917 1.283-1.775l-.097-.314c-.468-1.513-1.842-2.556-3.411-2.556h-.571A4.42 4.42 0 0 0 8.869 9.4H7.131a4.42 4.42 0 0 0-2.862 1.055zm1.161 1.063a3.233 3.233 0 0 1 2.249-.918h1.738a3.23 3.23 0 0 1 2.249.918c.4.386.71.878.886 1.447l.126.41c.087.279-.12.522-.35.525H4.22c-.23-.003-.436-.246-.35-.526l.127-.41c.176-.568.486-1.06.886-1.446m-1.644.188a2.41 2.41 0 0 0-1.782 1.66l-.097.314a.18.18 0 0 0 .024.159q.047.062.112.061h1.206c-.071-.28-.07-.583.022-.88l.127-.41q.15-.48.388-.904M13.299 13.9h1.228a.13.13 0 0 0 .113-.062c.03-.043.042-.099.024-.158l-.097-.314a2.41 2.41 0 0 0-1.808-1.665q.24.427.39.909l.128.41c.092.297.094.6.022.88" /></g><defs><clipPath id="Team_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;